import { Select } from "antd";
import { NamePath } from "antd/lib/form/interface";
import { clsx } from "clsx";

import { RVFormItem } from "@regal-voice/ui";
import { JoinType } from "Types/Segment";

import styles from "./JoinSelect.module.scss";

export type JoinSelectProps = {
    name: NamePath;
    prefix: string;
    sufix: string;
};
export function JoinSelect({ name, prefix, sufix }: JoinSelectProps): JSX.Element {
    return (
        <div className={clsx(styles.joinContainer, "flex-row align-center")}>
            {prefix}&nbsp;&nbsp;
            <RVFormItem name={name} noStyle>
                <Select size="middle" className={styles.joinSelect} data-testid={`join-select-${name}`}>
                    <Select.Option value={JoinType.ALL}>All</Select.Option>
                    <Select.Option value={JoinType.ANY}>Any</Select.Option>
                    <Select.Option value={JoinType.NONE}>None</Select.Option>
                </Select>
            </RVFormItem>
            &nbsp;&nbsp;{sufix}
        </div>
    );
}
